import { createProcessError } from '@upms/error-handling';
import { reporter } from '@upms/observability';

export const processError = createProcessError(reporter);
